import { signInWithCustomToken } from 'firebase/auth';
import { getFirebaseAuth } from '@boot/firebase';
import { api } from '@boot/axios';

const baseUrl = process.env.SERVER_URI;

export const fetchChatParticipants = async ({ commit, getters }, participantIds) => {
  const participantsResult = [];
  const filteredParticipantIds = participantIds.filter(
    (pId) => !getters.participantById(pId) && !getters.isPendingParticipant(pId),
  );
  if (filteredParticipantIds.length) {
    filteredParticipantIds.forEach((id) => {
      commit('addPendingParticipantId', id);
    });
    const res = await api.get(`${baseUrl}/api/chats/participants/info/${filteredParticipantIds.join(',')}`);
    const users = res.data?.data;
    if (users) {
      commit('addParticipants', users.filter((u) => u?.id));
    }
    filteredParticipantIds.forEach((id) => {
      commit('removePendingParticipantId', id);
    });
  }
  participantIds.forEach((pId) => {
    const found = getters.participantById(pId);
    if (found) {
      participantsResult.push(found);
    }
  });

  return participantsResult;
};

export const firebaseSignIn = async ({ commit }) => {
  const auth = await getFirebaseAuth();

  // User is logged in
  if (auth.currentUser?.uid) {
    return;
  }

  const tokenResponse = await api.get('/api/chats/get-token');
  const { token } = tokenResponse.data;
  await signInWithCustomToken(auth, token);
  commit('setToken', token);
};
